export default __webpack_public_path__ + "static/media/provesional_restoration_upper_48_2@2x.cb6408f3.png";